import { useEffect as o } from "react";
import { appEventBus as r } from "../appEventBus.js";
const t = (r2) => (t2, p2) => {
  o(() => r2.on(t2, (o2) => p2(o2)), [t2, p2]);
}, p = t(r);
export {
  t as createUseAppEventBus,
  p as useAppEventBus
};
//# sourceMappingURL=useAppEventBus.js.map
